import React from 'react';
import { useLoanNumber } from '../hooks/useLoanNumber';

/**
 * LoanReference — the borrower's file number, rendered next to a "contact us"
 * line so it is quotable at the moment someone is about to make contact.
 *
 * ⚠️ ONE COMPONENT, NOT THREE COPIES. The dashboard has three stage-specific
 * views that each end in "Questions? Email support…", and each needs this. Three
 * inline copies is how two of them end up saying something slightly different
 * from the third after the next edit.
 *
 * ⚠️ ONE NUMBER, TWO PEOPLE. loan_number identifies a FILE, not a person — a
 * co-borrower deliberately inherits the primary's number, so two users
 * legitimately share one. Saying so here is what stops "why is someone else on
 * my loan" arriving as a support ticket, and it sets the expectation that a
 * lookup on this number returns two rows rather than one.
 *
 * Renders NOTHING when no number is assigned. A lead who has not been through
 * underwriting has none, and a visible "Loan #: —" invites someone to quote a
 * dash to support.
 *
 * @param color     text colour, so this can sit on the light cards and the dark one
 * @param mutedColor colour for the secondary "shared with" clause
 */
export default function LoanReference({ color = '#6b7280', mutedColor = '#9ca3af' }) {
  const { loanNumber, isJoint } = useLoanNumber();
  if (!loanNumber) return null;

  return (
    <p className="mt-2 leading-relaxed" style={{ color, fontSize: 13 }}>
      Your loan file:{' '}
      <span style={{ fontFamily: 'ui-monospace, monospace', fontWeight: 600 }}>{loanNumber}</span>
      {isJoint && (
        <span style={{ color: mutedColor }}> · shared with your co-borrower</span>
      )}
    </p>
  );
}
